import React from 'react';
import {Form, Row, Col, Input, Button} from 'antd';

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
};

class ArrayInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: props.items ? props.items : [],
            first_item: props.items ? props.items[0] : null
        }

    }

    render() {
        const items = this.state.items;
        const field = this.props.field;
        const iterateKey = this.props.group + "-" + field;
        const label = this.props.label ? this.props.label : field;
        const options = this.props.options ? this.props.options : 0;

        let fieldsArray = [(<Row key={iterateKey}>{label}</Row>)];
        let rowIndex = -1;
        for (rowIndex in items) {
            if (typeof items[rowIndex] == typeof {}) {
                fieldsArray.push(<hr key={iterateKey+"-"+rowIndex+"-hr"}/>);
                let handleClose = this.props.handleClose != undefined ? this.props.handleClose : true;
                for (let itemFieldName in items[rowIndex]) {
                    fieldsArray.push(this.buildArrayInput(iterateKey, rowIndex, items[rowIndex][itemFieldName], itemFieldName, options[itemFieldName] != undefined ? options[itemFieldName] : {}, handleClose))
                    handleClose = false;

                }
            }
            else {
                fieldsArray.push(this.buildArrayInput(iterateKey, rowIndex, items[rowIndex]))
            }
        }
        let handleAdd = this.props.handleAdd != undefined ? this.props.handleAdd : true;
        if(handleAdd){
            rowIndex++;
            fieldsArray.push(<Row key={iterateKey+"-"+rowIndex}><Col span={20}><Button
                onClick={()=>{this.addArrayInput(iterateKey, options)}}
                style={{color: 'tomato', cursor: 'pointer'}}>اضافه
                کنید </Button></Col></Row>);
        }

        return (<div>{fieldsArray}</div>);
    }

    buildArrayInput(iterateKey, rowIndex, initialValue = '', itemFieldName = null, options = {}, handleClose = true) {
        let label = options && options['label'] ? options["label"] : itemFieldName;
        let closeBtn = handleClose ? (<span onClick={() => {this.props.removeArrayInput(this.props.field, rowIndex, itemFieldName)}}
                  className="fa fa-trash"
                  style={{color: 'tomato', cursor: 'pointer'}}>X </span>) : '';

        return (<Row key={iterateKey+"-"+rowIndex+(itemFieldName ? "-"+itemFieldName : "")}>
            <Col span={18} offset={1}>
                {this.buildFormItem(rowIndex, initialValue, itemFieldName, options)}
            </Col>
            {itemFieldName ? <Col span={1} offset={2}>{label}</Col> : ''}
            <Col span={1}>{closeBtn}</Col>
        </Row>);

    }

    addArrayInput = (k, options)=> {
        let items = this.state.items;
        let first_item = this.state.first_item;
        if (typeof first_item == typeof {}) {
            let newItem = {};
            for (let j in first_item) {
                newItem[j] = '';
            }
            items.push(newItem);
        }
        else {
            items.push('');
        }
        this.setState({items: items});
    }

    buildFormItem(rowIndex, initialValue = '', itemFieldName = null, options = {}) {
        let props = options ? (options['props'] ? options['props'] : {}) : {};
        let InputTag = '';
        if (options && options['partial'] != undefined) {
            let partial = options['partial'];
            partial.props['initialValue'] = initialValue;
            partial.props['update'] = (value, field) => {
                this.props.updateArrayValue(this.props.field, rowIndex, value, itemFieldName);
            };
            return this.props.formHandler.buildFormPartial({
                    field : this.props.field + "[" + rowIndex + "]" + (itemFieldName ? "[" + itemFieldName + "]" : ""),
                    partial :  partial,
                }, this.props.getFieldDecorator, this.props.group
            );
        }
        else if (options && options['type'] && options['type'] == "text_area") {
            InputTag = <Input.TextArea
                onChange={(e) => {this.props.updateArrayValue(this.props.field,rowIndex, e.target.value, itemFieldName)}} {...props}/>;
        }
        else {
            InputTag = <Input
                onChange={(e) => {this.props.updateArrayValue(this.props.field,rowIndex, e.target.value, itemFieldName)}} {...props}/>;
        }
        return (<Form.Item
            {...formItemLayout}
            colon={false}>
            {this.props.getFieldDecorator(this.props.field + "[" + rowIndex + "]" + (itemFieldName ? "[" + itemFieldName + "]" : ""), {
                initialValue: initialValue
            })(
                InputTag
            )}
        </Form.Item>);

    }
}

export default ArrayInput;


// WEBPACK FOOTER //
// ./src/containers/Pages/Partials/ArrayInput.js